import { CoffinIcon } from './CoffinIcon';

/**
 * author: Michael Irigoyen
 * id AC6E8289-8D3C-4CE0-ADA6-D17DC639B7FB
 * name coffin
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/coffin.svg
 * tags
 * - Holiday 
 */
export const DeadIcon = CoffinIcon;
export default DeadIcon